import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { EnelXGui } from 'gui-com-lib';
import {
  validateRegister,
} from '../../utils/formValidation';
import { CustomModal } from '../CustomModal';
import { PasswordValidation } from '../common/PasswordValidation';
import {
  generateRandomId, getLanguage, getCountry,
} from '../../utils/common';
import {
  StyledForm, StyledButton, Header, Divider,
} from '../../main.styled';
import { toastError } from '../common/ToastError';
import { getFromStorage, setInStorage } from '../../utils/storage';
import { registerAccount } from '../../api';

const {
  SingleInput, Button,
} = EnelXGui.EnelXGuiAtoms;

const { Loader } = EnelXGui.EnelXGuiComponents;

const ChangePassword = () => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(true);
  const [modalResult, setModalResult] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [countryCode, setCountryCode] = useState('');
  const [session, setSession] = useState(getFromStorage('userId'));
  const params = new URLSearchParams(document.location.search);
  const [newPassword, setNewPassword] = useState('');
  const [verifiedPassword, setVerifiedPassword] = useState('');
  const [accountOk, setAccountOk] = useState(false);

  const headers = {};

  // TODO: implement another api if needed since geolocation-db.com is down
  // const getIpData = async () => {
  //   try {
  //     const res = await axios.get('https://geolocation-db.com/json/');
  //     setIp(res?.data?.IPv4 || null);
  //     setCountryCode(res?.data?.country_code);
  //     localStorage.setItem('userIp', JSON.stringify(res?.data?.IPv4));
  //   } catch (error) {
  //     setIp(null);
  //   }
  // };

  const callBackUrl = params.get('callBackUrl') || '';
  const id = params.get('token');
  const country = params.get('country') || countryCode || getCountry();
  const language = params.get('language') || getLanguage();
  const source = params.get('source');

  useEffect(() => {
    if (!session) {
      const sId = generateRandomId();
      setSession(sId);
      setInStorage('userId', sId);
    }
  }, []);

  const onClose = () => {
    window.location.replace(callBackUrl);
  };

  const onSubmit = async () => {
    if (validateRegister(newPassword) && (newPassword === verifiedPassword)) {
      const changePassword = {
        country,
        language,
        newPassword,
        sessionId: session,
        touchpoint: 'string',
        source,
      };

      try {
        setIsFetching(true);

        const changedPassword = await registerAccount(changePassword, headers, id);
        if (changedPassword.data.data.success) {
          setIsFetching(false);
          setAccountOk(true);
          setModalOpen(false);
          setModalResult(true);
        }
      } catch (error) {
        setIsFetching(false);
        toastError(error?.response?.data?.message || error.message);
      }
    } else {
      setIsFetching(false);
      if (!validateRegister(newPassword)) {
        toastError(t('Toast_Pass_Incorrect'));
      }

      if (newPassword !== verifiedPassword) {
        toastError(t('Toast_Pass_Mismatch'));
      }
    }
    return null;
  };

  return (
    <>
      {
        isFetching && <Loader isSpinning />
      }
      { modalOpen && (
        <CustomModal
          height="901"
          width="432"
          position="relative"
          closeIcon
          closeModal={() => onClose()}
          render={() => (
            <StyledForm>
              <Header>{t('Change_Password_Title')}</Header>
              <SingleInput
                width="100%"
                type="password"
                placeholder={t('Password_Placeholder')}
                id="password"
                onChange={(e) => setNewPassword(e)}
              />
              <SingleInput
                width="100%"
                type="password"
                placeholder={t('Confirm_Password_Placeholder')}
                id="password"
                onChange={(e) => setVerifiedPassword(e)}
              />
              <PasswordValidation password={newPassword} verifiedPassword={verifiedPassword} />
              <Divider />
              <StyledButton>
                <Button
                  btnType="primary"
                  btnText="OK"
                  width="124px"
                  height="48px"
                  onClick={onSubmit}
                />
              </StyledButton>
            </StyledForm>

          )}
        />
      )}

      {modalResult && (
        <CustomModal
          height="auto"
          width="432px"
          className="modal"
          closeIcon={callBackUrl && true}
          closeModal={onClose}
          render={() => (
            <>
              <Header medium center>
                {accountOk ? t('Register_Success') : t('Register_Failed')}
              </Header>
              <StyledButton>
                {callBackUrl ? (
                  <Button
                    btnType="primary"
                    btnText={t('OK')}
                    width="84px"
                    height="48px"
                    onClick={onClose}
                  />
                ) : ''}
              </StyledButton>
            </>
          )}
        />
      )}
    </>
  );
};

export { ChangePassword };
